import _ from "lodash";
import {
  countryCodeValidation,
  mobileNumberValidation,
  urlValidation,
} from "../../../components/functions/formValidation";
import {
  UnderwritingSteps,
  uploadStates,
  validationErrorTypes,
} from "../../../interfaces/interfaces";
import { getIn } from "final-form";

export const founderRows = [
  {
    title: "Passport-sized Photo",
    key: "passportPhoto",
    subTitle: "",
    isMultiFile: false,
  },
  {
    title: "PAN Card",
    key: "panCard",
    subTitle: "",
    isMultiFile: false,
  },
  {
    title: "Aadhar Card",
    key: "aadharCard",
    subTitle: "Upload a clear copy from the Aadhar website or DigiLocker.",
    isMultiFile: false,
  },
  {
    title: "Address Proof",
    key: "addressProof",
    subTitle: "Mentioned address should match the residential address.",
    isMultiFile: false,
  },
];

export const directorLinkedInUrlValidation = (value) => {
  const error = urlValidation(value);
  if (error == validationErrorTypes.required) {
    return `Enter LinkedIn URL`;
  }
  if (error == validationErrorTypes.invalid) {
    return "Invalid URL";
  }
  return "";
};

export const directorSelectOptionValidation = (value) => {
  if (!value) {
    return "Select an Option";
  }
  return "";
};

export const diretorNameValidation = (value) => {
  if (!value) {
    return `Enter director's name`;
  }
  return "";
};

export const directorCareerHighlightsValidation = (values) => {
  let allEmpty = true;
  if (values?.length) {
    for (const value of values) {
      if (value) {
        allEmpty = false;
        break;
      }
    }
  } else {
    allEmpty = false;
  }
  if (allEmpty) {
    return "At least one career highlight is required ";
  } else return "";
};

export const directorMobileNumberValidation = (values) => {
  const error = mobileNumberValidation(values);
  if (error) {
    return `Enter a valid contact number`;
  }
  return "";
};

export const directorCountryCodeValdiation = (values) => {
  const error = countryCodeValidation(values);
  if (error) {
    return `Enter a valid country code`;
  }
  return "";
};

export const directorFields = [
  {
    key: "name",
    validatorFunc: diretorNameValidation,
  },
  {
    key: "contactDetail.phoneCode",
    validatorFunc: directorCountryCodeValdiation,
  },
  {
    key: "contactDetail.phoneNumber",
    validatorFunc: directorMobileNumberValidation,
  },
  {
    key: "activelyInvolved",
    validatorFunc: directorSelectOptionValidation,
  },
  {
    key: "isAddressSameAsAadhar",
    validatorFunc: directorSelectOptionValidation,
  },
  {
    key: "addressType",
    validatorFunc: directorSelectOptionValidation,
  },
];

export const validateDirectorFields = (values, underwritingFileJobs) => {
  let errors: any = {
    directors: [],
  };

  const missingData = [];
  const missingDocs = [];
  const requirePassword = [];
  const directorsArr = values?.directors;

  const directorsError = [];
  if (directorsArr && directorsArr?.length) {
    directorsArr?.forEach((item, index) => {
      let directorErrorsObj = {};
      directorFields.forEach((field) => {
        const error = field.validatorFunc(_.get(item, field.key));
        if (error) {
          _.set(directorErrorsObj, field.key, error);
          missingData.push(error);
        }
      });

      if (item?.activelyInvolved == "yes") {
        const careerHighlightsError = directorCareerHighlightsValidation(
          item?.careerHighlights
        );
        const linkedinUrlValidation = directorLinkedInUrlValidation(
          item?.linkedinProfile
        );
        if (careerHighlightsError) {
          // _.set(directorErrorsObj, "careerHighlights", careerHighlightsError);
          missingData.push(careerHighlightsError);
        }
        if (linkedinUrlValidation) {
          missingData.push(linkedinUrlValidation);
        }
      }
      const {
        errors: fileErrors,
        requirePassword,
        missingDocs,
      } = validateSingleDirectorDocs(item, underwritingFileJobs);
      directorErrorsObj = {
        ...directorErrorsObj,
        ...fileErrors,
      };
      missingDocs.push(...missingDocs);
      requirePassword.push(...requirePassword);
      directorsError.push(directorErrorsObj);
    });
  }

  errors = {
    ...errors,
    directors: directorsError,
  };

  return {
    errors,
    missingData,
    missingDocs,
    requirePassword,
  };
};

const validateSingleDirectorDocs = (director, underwritingFileJobs) => {
  let errors: any = {};
  const missingDocs = [];
  const requirePassword = [];
  const allDirectorDocs = getIn(
    underwritingFileJobs,
    `${UnderwritingSteps.director}`
  );
  founderRows.forEach((rowData) => {
    const directorDoc = director[rowData.key];
    if (!directorDoc || !directorDoc?.uploadedFile) {
      errors = {
        ...errors,
        [rowData.key]: {
          selectedFile: `Upload document`,
        },
      };
      missingDocs.push(`Upload document`);
    } else {
      const docJob = allDirectorDocs[`${rowData.key}`];
      if (docJob && docJob.status == uploadStates.requiredPassword) {
        errors = {
          ...errors,
          [rowData.key]: {
            uploadedFile: `Enter password`,
          },
        };
        requirePassword.push(`Enter password`);
      }
      requirePassword.push(`Enter password`);
    }
  });

  return {
    errors,
    missingDocs,
    requirePassword,
  };
};

export const validateDirectorDocs = (values, underwritingFileJobs) => {
  const directorsArr = values?.directors;
  let errors: any = {
    directors: [],
  };
  const missingDocs = [];
  const requirePassword = [];
  const allDirectorDocs = getIn(
    underwritingFileJobs,
    `${UnderwritingSteps.director}`
  );
  if (directorsArr && directorsArr.length) {
    directorsArr.forEach((director, index) => {
      founderRows.forEach((rowData) => {
        const directorDoc = director[rowData.key];
        if (!directorDoc || !directorDoc?.uploadedFile) {
          errors = {
            ...errors,
            [rowData.key]: {
              selectedFile: `Upload document`,
            },
          };
          missingDocs.push(`Upload document`);
        } else {
          const docJob = allDirectorDocs[`${rowData.key}`];
          if (docJob && docJob.status == uploadStates.requiredPassword) {
            errors = {
              ...errors,
              [rowData.key]: {
                uploadedFile: `Enter password`,
              },
            };
            requirePassword.push(`Enter password`);
          }
          requirePassword.push(`Enter password`);
        }
      });
    });
  }

  return {
    errors,
    missingDocs,
    requirePassword,
  };
};
